export const endPoints = {
  // permission
  getUserPermission: `operation/user/florist/florist-actions`,
  // orders
  ordersListData: `orders`,
  overdueOrdersList: `orders/overdue`,
  assignedOrdersList: `orders/assigned`,
  assignedOrdersCount: `orders/assigned/count`,
  subAndB2bOps: `sub-and-b2b-ops/{0}`,
  // Florist online / offline for automatic assignment - the florist comes from the token.
  availability: `auto-assignment/availability`,
  orderReassignments: `orders/{0}/reassignments`,
  // Preparation tasks: one task per cart line of an assigned order.
  preparationTasks: `order/{0}/preparation-tasks`,
  preparationTaskAction: `order/{0}/preparation-tasks/{1}/{2}`,
  preparationTasksHistory: `order/{0}/preparation-tasks/history`,
  // Hub service, so these are full paths off the api gateway.
  assignmentDroppedOrders: `operation/order/v2/FloristAssignment/dropped-orders`,
  assignmentFlorists: `operation/order/v2/FloristAssignment/florists`,
  getFloristsList: ``,
  orderDetails: `order/{0}/details`,
  cartDetails: `cart/{0}/details`,
  inventoryDetails: `operation/order/v2/florist/map/{0}/product-inventory-details/{1}/{2}/{3}`,
  basketDetails: `cart/{0}/basket-details`,
  getFavFlowersData: `catalog/hub/SubscriptionFavorites/{0}`,
  login: `operation/user/UserDetails/outsource/login`,
  session: `operation/user/authentication/sso/{0}/session`,
  country: `operation/home/countries`,
  completedOrders: `orders/completed`,
  assignFlorist: `assign/{0}`,
  changeOrderPreparationStatus: `change-order-preparation/{0}`,
  notDoneReasonsList: `cancel-preparation-reasons`,
  // group by
  groupedBy: `slots/{0}/orders/grouped`,
  // notifications
  getNotificationsList: `notifications`,
  getReadNotification: `notifications/{0}`,
  getProceedAck: `notification/{0}/done`,
  getRejectAck: `map/{0}/inventory-deviations`,
  // Production
  getUnassignedBatches: `prodapp/florist/unassigned-batches`,
  // Deviation
  getDeviationReasons: `inventory-deviation-reasons`,
  addDeviation: `map/{0}/inventory-deviations/{1}/{2}`,
  editDeviation: `map/{0}/change/inventory-deviations/{1}/{2}`,
  //Quality check
  uploadQcImage: `qc`,
  getQcImages: `operation/order/v2/florist/production-qc/{0}`,
  //AI Quality check
  //production jobs
  getProductionJobsCount: `productionJobs/counts`,
  getProductionJobsList: `productionJobs`,
  assignProduction: `assign-production/{0}`,
  changeProdJobStatus: `change-preparation/{0}`,
  getProdJobDetails: `productionJobs/{0}/details`,
  getProdJobCartDetails: `productionJobs/details/{0}`,
  uploadQcPjImages: `productionJobs/qc`,
  getProdJobsQcImages: `productionJobs/production-qc/{0}`,
  getProdJobInventoryDetails: `productionJobs/details/{0}`,
  addProdJobDeviation: `production-job/{0}/inventory-deviations/{1}`,
  // Express orders
  expressOrdersListing: `express/listing`,
  expressOrdersCount: `express/count`,
  // Pause
  pauseReasons: `pause-reasons`,
  // Feature flags
};
